import axios from "axios";

export const getRequestAPI = (id) => axios.get(`{server}/admin/users/providers/requests/${id}`).then(res => res.data.success);
export const acceptRequestAPI = (id) => axios.post(`{server}/admin/users/providers/requests/${id}/accept`).then(res => res.data.success);
export const declineRequestAPI = (id) => axios.post(`{server}/admin/users/providers/requests/${id}/reject`).then(res => res.data.success);